import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d167e4b0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d167e4b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d167e4b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d167e4b0')) {
      api.createRecord('d167e4b0', component.options)
    } else {
      api.reload('d167e4b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d167e4b0&scoped=true&", function () {
      api.rerender('d167e4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterTemplate/index.vue"
export default component.exports